<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { advancedReportsApi, type ReportMatrix } from '@/services/api/emsl';

const route = useRoute();
const matrices = ref<ReportMatrix[]>([]);
const selectedMatrix = ref<number | null>(null);
const loading = ref(false);

async function loadMatrices(): Promise<void> {
  matrices.value = await advancedReportsApi.matrices();
}

async function generate(): Promise<void> {
  if (selectedMatrix.value === null) return;
  loading.value = true;
  try {
    const code =
      typeof route.params.reservationCode === 'string' ? route.params.reservationCode : undefined;
    await advancedReportsApi.generate(selectedMatrix.value, code);
  } finally {
    loading.value = false;
  }
}

onMounted(loadMatrices);
</script>

<template>
  <section class="resource">
    <h1>Advanced Reports</h1>
    <form class="resource__new" @submit.prevent="generate">
      <select v-model.number="selectedMatrix">
        <option :value="null">Select a matrix…</option>
        <option v-for="m in matrices" :key="m.id" :value="m.id">{{ m.name }}</option>
      </select>
      <button type="submit" :disabled="selectedMatrix === null || loading">
        {{ loading ? 'Generating…' : 'Generate Report' }}
      </button>
    </form>
    <p class="resource__note">
      Highcharts visualization is wired in QA (task #37) — this view drives the
      backend report job today.
    </p>
  </section>
</template>

<style scoped src="@/assets/styles/resource-list.scss"></style>
<style scoped>
.resource__note {
  margin-top: 1rem;
  color: #6b7280;
  font-size: 0.875rem;
}
</style>
